export default function Footer() {
    return (
        <footer
            className="border-t border-t22252a mt-24 py-10 px-4 sm:px-6 lg:px-8"
            data-testid="site-footer"
        >
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                    <img
                        src="/op-logo.png"
                        alt="Original PES"
                        className="w-8 h-8 object-contain"
                    />
                    <div className="op-label">
                        Original PES · <span style={{ color: "rgb(var(--tc-ff7a1a))" }}>Stagione 25</span>
                    </div>
                </div>
                <div className="op-label text-[10px]">
                    Costruito su passione e regolamento. v1 — Fase 1
                </div>
            </div>
        </footer>
    );
}
